import type { Comment } from '@/@types/comment'
import type { GetCommentParams } from '@/utils/fetchers/comment'
import type { ComponentProps, ReactNode } from 'react'
import CommentItem from './CommentItem'
import CommentRepliesSection from './CommentRepliesSection'

export interface CommentThreadProps extends Omit<
	ComponentProps<typeof CommentItem>,
	'data' | 'replies'
> {
	data: Comment
	renderReply?: (data: GetCommentParams) => ReactNode
}

export default function CommentThread({ data, renderReply, ...props }: CommentThreadProps) {
	return (
		<CommentItem
			data={data}
			replies={
				renderReply ? <CommentRepliesSection data={data} renderComment={renderReply} /> : undefined
			}
			{...props}
		/>
	)
}
